/* DrankThuis, front end gedrag. Geen externe bibliotheken. */
(function () {
  'use strict';

  var CFG = window.DrankThuis || { routes: {}, settings: {}, strings: {} };

  /* ---------------------------------------------------------- hulpjes */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return '€ ' + value;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* ------------------------------------------------- leeftijdscontrole */

  function initAgeGate() {
    var dialog = $('[data-age-gate]');
    if (!dialog) return;
    if (localStorage.getItem('dt-age-ok') === '1') return;

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    dialog.addEventListener('cancel', function (e) { e.preventDefault(); });

    var yes = $('[data-age-gate-yes]', dialog);
    var no = $('[data-age-gate-no]', dialog);
    var denied = $('[data-age-gate-denied]', dialog);

    if (yes) yes.addEventListener('click', function () {
      localStorage.setItem('dt-age-ok', '1');
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    });

    if (no) no.addEventListener('click', function () {
      if (denied) denied.hidden = false;
      if (yes) yes.disabled = true;
    });
  }

  /* --------------------------------------- header die meebeweegt */

  /**
   * De bovenbalk schuift zacht weg zodra je naar beneden leest en komt
   * meteen terug zodra je omhoog scrolt.
   */
  function initStickyHeader() {
    var header = $('[data-header]');
    if (!header) return;

    var vorige = window.pageYOffset;
    var bezig = false;

    function meten() {
      var nu = window.pageYOffset;
      var hoogte = header.offsetHeight || 80;

      header.classList.toggle('is-zwevend', nu > 4);

      // wie in het zoekveld staat, houdt de balk in beeld
      if (header.contains(document.activeElement)) {
        header.classList.remove('is-verborgen');
        vorige = nu;
        bezig = false;
        return;
      }

      if (nu <= hoogte) {
        header.classList.remove('is-verborgen');
      } else if (nu > vorige + 4) {
        header.classList.add('is-verborgen');
      } else if (nu < vorige - 4) {
        header.classList.remove('is-verborgen');
      }

      vorige = nu;
      bezig = false;
    }

    window.addEventListener('scroll', function () {
      if (bezig) return;
      bezig = true;
      requestAnimationFrame(meten);
    }, { passive: true });

    meten();
  }

  function initNav() {
    var knop = $('[data-nav-toggle]');
    var paneel = $('[data-mobile-nav]');
    var achtergrond = $('.lade-achtergrond');
    if (!knop || !paneel) return;

    function open() {
      paneel.hidden = false;
      if (achtergrond) achtergrond.hidden = false;
      // een tel wachten zodat de overgang zichtbaar is
      requestAnimationFrame(function () { paneel.classList.add('is-open'); });
      knop.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function sluit() {
      paneel.classList.remove('is-open');
      knop.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () {
        paneel.hidden = true;
        if (achtergrond) achtergrond.hidden = true;
      }, 260);
    }

    knop.addEventListener('click', function () {
      if (knop.getAttribute('aria-expanded') === 'true') sluit(); else open();
    });
    $$('[data-nav-close]').forEach(function (el) { el.addEventListener('click', sluit); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !paneel.hidden) sluit();
    });
  }



  /* ------------------------------------------- zijwaarts scrollende rijen */


  /* ---------------------------------------------------- aantalkiezers */

  function initQuantity(root) {
    $$('[data-qty]', root || document).forEach(function (wrap) {
      var input = $('.qty__input', wrap);
      if (!input) return;
      var down = $('[data-qty-down]', wrap);
      var up = $('[data-qty-up]', wrap);
      if (down) down.addEventListener('click', function () {
        input.value = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (up) up.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 0) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function initCartLines() {
    $$('.cart-item .qty').forEach(function (wrap) {
      var input = $('[data-line-input]', wrap);
      if (!input) return;
      var regel = wrap.closest('.cart-item');
      var variantId = regel ? regel.dataset.variantId : null;
      var depositId = regel ? regel.dataset.depositVariantId : null;
      var form = document.getElementById('cart-form');

      function zet(nieuwAantal) {
        nieuwAantal = Math.max(0, nieuwAantal);
        input.value = nieuwAantal;

        // zonder waarborg volstaat het gewone formulier
        if (!depositId || !variantId) {
          if (form) form.submit();
          return;
        }

        var updates = {};
        updates[variantId] = nieuwAantal;
        updates[depositId] = nieuwAantal;

        fetch(CFG.routes.cartUpdate, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function () { window.location.reload(); })
          .catch(function () { if (form) form.submit(); });
      }

      var down = $('[data-line-down]', wrap);
      var up = $('[data-line-up]', wrap);
      if (down) down.addEventListener('click', function () { zet((parseInt(input.value, 10) || 0) - 1); });
      if (up) up.addEventListener('click', function () { zet((parseInt(input.value, 10) || 0) + 1); });
      input.addEventListener('change', function () { zet(parseInt(input.value, 10) || 0); });
    });
  }

  /* ------------------------------------------------------- ballonnetjes */

  function initTips() {
    $$('[data-tip]').forEach(function (knop) {
      var bubbel = $('[data-tip-bubble]', knop.parentNode);
      if (!bubbel) return;

      function toon(aan) {
        knop.setAttribute('aria-expanded', aan ? 'true' : 'false');
        bubbel.hidden = !aan;
      }

      knop.addEventListener('click', function (e) {
        e.stopPropagation();
        toon(bubbel.hidden);
      });
      knop.addEventListener('mouseenter', function () { toon(true); });
      knop.parentNode.addEventListener('mouseleave', function () { toon(false); });
      document.addEventListener('click', function () { toon(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') toon(false); });
    });
  }

  /* ------------------------------------------------ toevoegen aan mandje */

  /**
   * Voegt een drank toe, en hangt er de leeggoedwaarborg aan vast.
   * De waarborg gaat mee als tweede regel met parent_id, zodat Shopify hem
   * aan de drank koppelt en de klant hem niet los kan verwijderen.
   */
  function voegToe(variantId, aantal, depositVariantId) {
    var items = [{ id: Number(variantId), quantity: aantal }];

    if (depositVariantId) {
      items.push({
        id: Number(depositVariantId),
        quantity: aantal,
        parent_id: Number(variantId)
      });
    }

    return fetch(CFG.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message); });
      return r.json();
    });
  }

  function ververatMandje() {
    return fetch(CFG.routes.cart + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }

  function knopFeedback(button, tekst, duur) {
    if (!button) return;
    var origineel = button.dataset.origineel || button.textContent;
    button.dataset.origineel = origineel;
    button.textContent = tekst;
    setTimeout(function () { button.textContent = origineel; button.disabled = false; }, duur || 1600);
  }

  /**
   * Het ronde knopje op de productkaart.
   * Eerste tik legt het product in het mandje en klapt open naar een teller.
   * Daarna tel je met plus en min, zonder de pagina te verlaten.
   */
  function initQadd() {
    var kaarten = $$('[data-qadd]');
    if (!kaarten.length) return;

    function teken(el, n) {
      var open = $('[data-qadd-open]', el);
      var step = $('[data-qadd-step]', el);
      var getal = $('[data-qadd-n]', el);
      if (getal) getal.textContent = n;
      if (open) open.hidden = n > 0;
      if (step) step.hidden = n < 1;
      el.dataset.aantal = n;
    }

    /* de foto dimt even en er verschijnt een vinkje met een woordje */
    function gelukt(el) {
      var kaart = el.closest('.kaart');
      var vak = kaart ? $('.kaart__beeld', kaart) : null;
      if (!vak || !kaart) return;

      var oud = $('.gelukt', vak);
      if (oud) oud.remove();
      clearTimeout(kaart._gelukt);

      var melding = document.createElement('span');
      melding.className = 'gelukt';
      melding.innerHTML =
        '<span class="gelukt__vink"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" ' +
        'stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M20 6 9 17l-5-5"/></svg></span>' +
        '<span class="gelukt__tekst">' + CFG.strings.addedToCart + '</span>';
      vak.appendChild(melding);
      kaart.classList.add('is-toegevoegd');

      kaart._gelukt = setTimeout(function () {
        kaart.classList.remove('is-toegevoegd');
        melding.remove();
      }, 1400);
    }

    function verstuur(el, n) {
      var vId = el.dataset.variantId;
      var dId = el.dataset.depositVariantId;
      var was = el._server || 0;
      if (n === was) return;

      el.classList.add('is-bezig');

      var af;
      if (was === 0) {
        af = voegToe(vId, n, dId);
      } else {
        var updates = {};
        updates[vId] = n;
        if (dId) updates[dId] = n;
        af = fetch(CFG.routes.cartUpdate, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); });
      }

      af.then(function () { el._server = n; return ververatMandje(); })
        .then(function () { el.classList.remove('is-bezig'); })
        .catch(function () { el.classList.remove('is-bezig'); teken(el, was); });
    }

    function plan(el, n) {
      n = Math.max(0, n);
      var vorig = parseInt(el.dataset.aantal, 10) || 0;
      teken(el, n);
      if (n > vorig) gelukt(el);
      clearTimeout(el._qtimer);
      el._qtimer = setTimeout(function () { verstuur(el, n); }, 350);
    }

    kaarten.forEach(function (el) {
      if (el._gebonden) return;
      el._gebonden = true;
      el._server = 0;
      teken(el, 0);

      var open = $('[data-qadd-open]', el);
      var min = $('[data-qadd-min]', el);
      var plus = $('[data-qadd-plus]', el);

      if (open) open.addEventListener('click', function (e) {
        e.preventDefault();
        plan(el, 1);
      });
      if (plus) plus.addEventListener('click', function (e) {
        e.preventDefault();
        plan(el, (parseInt(el.dataset.aantal, 10) || 0) + 1);
      });
      if (min) min.addEventListener('click', function (e) {
        e.preventDefault();
        plan(el, (parseInt(el.dataset.aantal, 10) || 0) - 1);
      });
    });

    // wat al in het mandje ligt meteen laten zien
    fetch(CFG.routes.cart + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var per = {};
        (cart.items || []).forEach(function (i) {
          if (i.parent_relationship && i.parent_relationship.parent) return;
          per[i.variant_id] = (per[i.variant_id] || 0) + i.quantity;
        });
        kaarten.forEach(function (el) {
          var n = per[el.dataset.variantId] || 0;
          el._server = n;
          teken(el, n);
        });
      })
      .catch(function () {});
  }

  function initProductForm() {
    var wrap = $('[data-product-form]');
    if (!wrap) return;
    var form = $('form', wrap);
    if (!form) return;

    form.addEventListener('submit', function (e) {
      // de betaalknop van Shopify laten wij met rust
      if (document.activeElement && document.activeElement.name === 'checkout') return;

      e.preventDefault();
      var button = $('button[type="submit"]', form);
      var idVeld = $('[name="id"]', form);
      var aantalVeld = $('[name="quantity"]', form);
      if (!idVeld) return;

      if (button) { button.disabled = true; button.textContent = '...'; }


      voegToe(
        idVeld.value,
        parseInt(aantalVeld ? aantalVeld.value : 1, 10) || 1,
        wrap.dataset.depositVariantId
      )
        .then(ververatMandje)
        .then(function () { knopFeedback(button, CFG.strings.addedToCart, 1800); })
        .catch(function () {
          if (button) { button.disabled = false; button.textContent = CFG.strings.error; }
        });
    });
  }

  function updateCartCount(count) {
    var el = $('[data-cart-count]');
    if (!el) return;
    el.textContent = count;
  }

  /* --------------------------------------------------- tijdsloten */

  function isoWeek(date) {
    var d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    var day = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - day);
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  }

  // Live leverslots komen uit Supabase (single source of truth voor
  // capaciteit) via een publieke, read-only Edge Function — niet meer uit
  // een statische thema-instelling. Zie supabase/functions/available-slots.
  var SLOTS_API = 'https://ojrhzrrjlauclxmeflqz.supabase.co/functions/v1/available-slots';

  function initTimeslot() {
    var root = $('[data-timeslot]');
    if (!root) return;

    var postcodeInput = $('[data-timeslot-postcode]', root);
    var zoneWrap = $('[data-timeslot-zone]', root);
    var zoneName = $('[data-timeslot-zone-name]', root);
    var outside = $('[data-timeslot-outside]', root);
    var body = $('[data-timeslot-body]', root);
    var daysWrap = $('[data-timeslot-days]', root);
    var slotsWrap = $('[data-timeslot-slots]', root);
    var slotHint = $('[data-timeslot-slot-hint]', root);
    var recurringWrap = $('[data-timeslot-recurring-wrap]', root);

    var dayField = $('[data-timeslot-day-field]', root);
    var slotField = $('[data-timeslot-slot-field]', root);
    var zoneField = $('[data-timeslot-zone-field]', root);
    var postcodeField = $('[data-timeslot-postcode-field]', root);
    var slotIdField = $('[data-timeslot-slotid-field]', root);

    var locale = (document.documentElement.lang || 'nl').slice(0, 2);
    var dayNames = {
      nl: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
      en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      fr: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
    };
    var monthNames = {
      nl: ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'],
      en: ['January','February','March','April','May','June','July','August','September','October','November','December'],
      fr: ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre']
    };

    function labelForDate(iso) {
      var d = new Date(iso + 'T00:00:00');
      var dn = (dayNames[locale] || dayNames.nl)[d.getDay()];
      var mn = (monthNames[locale] || monthNames.nl)[d.getMonth()];
      return dn + ' ' + d.getDate() + ' ' + mn;
    }

    // enkel de cijfers tellen, zo werkt ook "B-2300" of "2300 "
    function schoonZip(waarde) {
      return String(waarde || '').replace(/[^0-9]/g, '').slice(0, 4);
    }

    var beschikbaar = {}; // { iso-datum: [ {id, startTijd, eindTijd, label, plaatsenVrij}, ... ] }
    var requestToken = 0;

    function buildDays() {
      daysWrap.innerHTML = '';
      var isos = Object.keys(beschikbaar).sort();
      var gevonden = 0;

      isos.forEach(function (iso) {
        if (gevonden >= 10) return;
        var slots = beschikbaar[iso];
        if (!slots.length) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'slot-btn';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', dayField.value === iso ? 'true' : 'false');
        btn.dataset.date = iso;
        btn.innerHTML = labelForDate(iso) + '<small>' + slots.length + ' × 1u</small>';
        btn.addEventListener('click', function () { selectDay(this); });
        daysWrap.appendChild(btn);
        gevonden++;
      });

      if (!gevonden) {
        var leeg = document.createElement('p');
        leeg.className = 'muted';
        leeg.textContent = root.dataset.noDays || '';
        daysWrap.appendChild(leeg);
      }

      // een eerder gekozen dag die niet meer kan, wissen
      if (dayField.value && !beschikbaar[dayField.value]) {
        dayField.value = '';
        slotField.value = '';
        slotIdField.value = '';
      }
    }

    function selectDay(btn) {
      $$('button', daysWrap).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      btn.setAttribute('aria-checked', 'true');
      if (dayField.value !== btn.dataset.date) { slotField.value = ''; slotIdField.value = ''; }
      dayField.value = btn.dataset.date;
      buildSlots();
      if (recurringWrap) recurringWrap.hidden = false;
    }

    function buildSlots() {
      slotsWrap.innerHTML = '';
      var slots = beschikbaar[dayField.value];
      if (!slots || !slots.length) { slotHint.hidden = false; return; }
      slotHint.hidden = true;

      slots.forEach(function (slot) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'slot-btn';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', slotIdField.value === slot.id ? 'true' : 'false');
        btn.dataset.slotId = slot.id;
        btn.textContent = slot.startTijd + '–' + slot.eindTijd;
        btn.addEventListener('click', function () {
          $$('button', slotsWrap).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
          this.setAttribute('aria-checked', 'true');
          slotField.value = slot.startTijd + '-' + slot.eindTijd;
          slotIdField.value = slot.id;
        });
        slotsWrap.appendChild(btn);
      });
    }

    function toonBuitenZone() {
      zoneWrap.hidden = true; body.hidden = true; outside.hidden = false;
      if (recurringWrap) recurringWrap.hidden = true;
      zoneField.value = '';
      slotIdField.value = '';
    }

    function toonLeeg() {
      zoneWrap.hidden = true; outside.hidden = true; body.hidden = true;
      if (recurringWrap) recurringWrap.hidden = true;
    }

    function refresh() {
      var zip = schoonZip(postcodeInput.value);
      postcodeField.value = zip;

      if (zip.length < 4) { toonLeeg(); return; }

      var myToken = ++requestToken;
      fetch(SLOTS_API + '?postcode=' + encodeURIComponent(zip))
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (myToken !== requestToken) return; // een nieuwere postcode-invoer telt, niet dit antwoord
          if (!data || !data.inZone) { toonBuitenZone(); return; }

          outside.hidden = true;
          zoneWrap.hidden = false;
          zoneName.textContent = data.gemeente;
          zoneField.value = data.gemeente;
          body.hidden = false;

          beschikbaar = {};
          (data.slots || []).forEach(function (slot) {
            if (!beschikbaar[slot.datum]) beschikbaar[slot.datum] = [];
            beschikbaar[slot.datum].push(slot);
          });

          buildDays();
          buildSlots();
          if (recurringWrap) recurringWrap.hidden = !dayField.value;
        })
        .catch(function () {
          if (myToken !== requestToken) return;
          toonLeeg();
        });
    }

    ['input', 'change', 'blur', 'paste'].forEach(function (ev) {
      postcodeInput.addEventListener(ev, function () { setTimeout(refresh, 250); });
    });
    refresh();
  }


  /* --------------------------------------------------- afrekenknop */

  function initCheckoutGuard() {
    var button = $('[data-checkout-button]');
    var root = $('[data-timeslot]');
    if (!button || !root) return;

    var dayField = $('[data-timeslot-day-field]', root);
    var slotField = $('[data-timeslot-slot-field]', root);

    button.addEventListener('click', function (e) {
      if (!dayField.value || !slotField.value) {
        e.preventDefault();
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        root.style.borderColor = 'var(--color-danger)';
        setTimeout(function () { root.style.borderColor = ''; }, 2400);
      }
    });
  }


  /* ------------------------------------------- categoriemenu met twee lagen */

  function initCatMenu() {
    var menu = $('[data-catmenu]');
    if (!menu) return;

    var laag1 = $('[data-catmenu-laag1]', menu);
    var lagen2 = $$('[data-catmenu-laag2]', menu);

    var body = menu.closest('[data-lade-body]');

    function toonLaag1() {
      laag1.hidden = false;
      lagen2.forEach(function (l) { l.hidden = true; });
      if (body) { body.classList.remove('is-laag2'); body.scrollTop = 0; }
    }

    $$('[data-catmenu-naar]', menu).forEach(function (knop) {
      knop.addEventListener('click', function (e) {
        e.preventDefault();
        var doel = $('[data-catmenu-laag2="' + knop.dataset.catmenuNaar + '"]', menu);
        if (!doel) return;
        laag1.hidden = true;
        lagen2.forEach(function (l) { l.hidden = l !== doel; });
        if (body) { body.classList.add('is-laag2'); body.scrollTop = 0; }
      });
    });

    $$('[data-catmenu-terug]', menu).forEach(function (knop) {
      knop.addEventListener('click', toonLaag1);
    });

    // gaat het menu dicht, dan staan we de volgende keer weer vooraan
    var sluiters = $$('[data-nav-close]');
    sluiters.forEach(function (k) { k.addEventListener('click', toonLaag1); });
  }

  /* ------------------------------------------ zoeken terwijl je typt */

  function initZoek() {
    var balk = $('[data-zoek]');
    if (!balk) return;

    var veld = $('[data-zoek-veld]', balk);
    var uit = $('[data-zoek-uit]', balk);
    var wis = $('[data-zoek-wis]', balk);
    if (!veld || !uit) return;

    var timer = null;
    var laatste = '';

    function verberg() { uit.hidden = true; }

    function teken(data, term) {
      var r = (data.resources && data.resources.results) || {};
      var producten = r.products || [];
      var collecties = r.collections || [];
      var paginas = r.pages || [];

      if (!producten.length && !collecties.length && !paginas.length) {
        uit.innerHTML = '<p class="zoekleeg">' + CFG.strings.searchEmpty + '</p>';
        uit.hidden = false;
        return;
      }

      var html = '';

      if (collecties.length) {
        html += '<div class="zoekkopje">' + CFG.strings.searchCategories + '</div>';
        collecties.slice(0, 4).forEach(function (c) {
          var beeld = c.featured_image && c.featured_image.url
            ? '<img src="' + c.featured_image.url + '" alt="" loading="lazy">'
            : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
              'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
              '<path d="M4 7h16l-1.4 11.2A2 2 0 0 1 16.6 20H7.4a2 2 0 0 1-2-1.8L4 7Z"/>' +
              '<path d="M8.5 7V5.5a3.5 3.5 0 0 1 7 0V7"/></svg>';
          html += '<a class="zoekrij" href="' + c.url + '">' +
            '<span class="zoekrij__beeld' + (c.featured_image && c.featured_image.url ? '' : ' zoekrij__beeld--pagina') + '">' + beeld + '</span>' +
            '<span class="zoekrij__naam">' + c.title + '</span></a>';
        });
      }

      if (producten.length) {
        html += '<div class="zoekkopje">' + CFG.strings.searchProducts + '</div>';
        producten.forEach(function (pr) {
          var beeld = pr.featured_image && pr.featured_image.url ? '<img src="' + pr.featured_image.url + '" alt="" loading="lazy">' : '';
          html += '<a class="zoekrij" href="' + pr.url + '">' +
            '<span class="zoekrij__beeld">' + beeld + '</span>' +
            '<span class="zoekrij__naam">' + pr.title + '</span></a>';
        });
      }

      if (paginas.length) {
        html += '<div class="zoekkopje">' + CFG.strings.searchPages + '</div>';
        paginas.slice(0, 3).forEach(function (pg) {
          html += '<a class="zoekrij" href="' + pg.url + '">' +
            '<span class="zoekrij__beeld zoekrij__beeld--pagina">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/>' +
            '<path d="M14 3v5h5M9 13h6M9 17h4"/></svg></span>' +
            '<span class="zoekrij__naam">' + pg.title + '</span></a>';
        });
      }

      html += '<a class="zoekalles" href="' + CFG.routes.search + '?q=' + encodeURIComponent(term) + '">' +
        CFG.strings.searchAll + '</a>';

      uit.innerHTML = html;
      uit.hidden = false;
    }

    function zoek(term) {
      var url = CFG.routes.predictive + '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6&resources[options][unavailable_products]=last';

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (veld.value.trim() !== term) return;
          teken(data, term);
        })
        .catch(verberg);
    }

    veld.addEventListener('input', function () {
      var term = veld.value.trim();
      if (wis) wis.hidden = term.length === 0;
      clearTimeout(timer);
      if (term.length < 2) { verberg(); laatste = ''; return; }
      if (term === laatste) { uit.hidden = false; return; }
      laatste = term;
      timer = setTimeout(function () { zoek(term); }, 150);
    });

    veld.addEventListener('focus', function () {
      if (veld.value.trim().length >= 2 && uit.innerHTML) uit.hidden = false;
    });

    if (wis) wis.addEventListener('click', function () {
      veld.value = ''; wis.hidden = true; verberg(); laatste = ''; veld.focus();
    });

    document.addEventListener('click', function (e) {
      if (!balk.contains(e.target)) verberg();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { verberg(); veld.blur(); }
    });
  }

  /* ------------------------------------------ toevoegen aan het beginscherm */

  /**
   * Vangt de officiele installatievraag van de browser op en toont onze
   * eigen knop. Op een iPhone bestaat die vraag niet, daar tonen wij de
   * twee stappen die Safari verwacht.
   */
  function initInstalleer() {
    var vak = $('[data-installeer]');
    if (!vak) return;

    var knop = $('[data-installeer-knop]', vak);
    var sub = $('[data-installeer-sub]', vak);

    var alsApp = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    if (alsApp) return;

    var isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
    var isSafari = isIos && /safari/i.test(window.navigator.userAgent) && !/crios|fxios/i.test(window.navigator.userAgent);

    if (isIos) {
      if (isSafari && sub && CFG.strings.pwaNoteIos) sub.textContent = CFG.strings.pwaNoteIos;
      if (isSafari) vak.hidden = false;
      return;
    }

    var bewaard = null;

    window.addEventListener('beforeinstallprompt', function (e) {
      e.preventDefault();
      bewaard = e;
      vak.hidden = false;
      if (knop) knop.hidden = false;
    });

    if (knop) knop.addEventListener('click', function () {
      if (!bewaard) return;
      knop.disabled = true;
      bewaard.prompt();
      bewaard.userChoice.then(function () {
        bewaard = null;
        vak.hidden = true;
      });
    });

    window.addEventListener('appinstalled', function () { vak.hidden = true; });
  }

  /* --------------------------------------------- draaiende dranken op pc */

  /**
   * De dranken in de hero schuiven rustig langs elkaar. De drank in het
   * midden staat groot, de buren kleiner en lichter. Enkel op een breed
   * scherm, want op een telefoon staat deze carrousel niet in beeld.
   */
  function initCarrousel() {
    $$('[data-carrousel]').forEach(function (wrap) {
      var items = $$('[data-carrousel-item]', wrap);
      if (items.length < 3) return;

      var aantal = items.length;
      var actief = 0;
      var timer = null;
      var pas = parseInt(wrap.dataset.carrouselPas, 10) || 62;
      // met weinig dranken tonen wij er minder naast elkaar, anders valt er een gat
      var zicht = Math.min(2, Math.floor((aantal - 1) / 2));

      function teken() {
        items.forEach(function (el, i) {
          var d = i - actief;
          if (d > aantal / 2) d -= aantal;
          if (d < -aantal / 2) d += aantal;

          var ver = Math.abs(d);
          el.hidden = ver > zicht;
          if (el.hidden) return;

          var schaal = 1 - ver * 0.26;
          el.style.transform =
            'translate(-50%, -50%) translateX(' + (d * pas) + '%) scale(' + schaal + ')';
          el.style.opacity = ver === 0 ? '1' : (ver === 1 ? '0.6' : '0.25');
          el.style.zIndex = String(10 - ver);
          el.classList.toggle('is-actief', ver === 0);
        });
      }

      function stap(richting) {
        actief = (actief + richting + aantal) % aantal;
        teken();
      }

      function start() {
        if (timer) return;
        timer = setInterval(function () { stap(1); }, 3400);
      }
      function stop() { clearInterval(timer); timer = null; }

      var vorig = $('[data-carrousel-vorig]', wrap);
      var volgend = $('[data-carrousel-volgend]', wrap);
      if (vorig) vorig.addEventListener('click', function () { stap(-1); stop(); start(); });
      if (volgend) volgend.addEventListener('click', function () { stap(1); stop(); start(); });

      wrap.addEventListener('mouseenter', stop);
      wrap.addEventListener('mouseleave', start);

      teken();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // de carrousel in de hero draait enkel op een breed scherm
      if (wrap.dataset.carrouselBreed === 'true') {
        var breed = window.matchMedia('(min-width: 900px)');
        var regel = function () { if (breed.matches) start(); else stop(); };
        if (breed.addEventListener) breed.addEventListener('change', regel);
        regel();
      } else {
        start();
      }
    });
  }

  /* ------------------------------------------------------------ start */

  /* -------------------------------------------------- meer dranken laden */

  /**
   * Haalt de volgende pagina op en hangt de dranken onderaan de lijst.
   * Zonder javascript blijft de gewone paginering gewoon staan.
   */
  function initMeer() {
    var knop = $('[data-meer]');
    if (!knop) return;

    var lijst = $('[data-lijst]');
    if (!lijst) return;

    var telling = $('[data-meer-telling]');
    var bezig = false;

    knop.addEventListener('click', function () {
      if (bezig) return;
      var url = knop.dataset.meerUrl;
      if (!url) return;

      bezig = true;
      var origineel = knop.textContent;
      knop.textContent = '...';

      fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nieuweLijst = doc.querySelector('[data-lijst]');
          if (nieuweLijst) {
            Array.prototype.slice.call(nieuweLijst.children).forEach(function (kaart) {
              lijst.appendChild(kaart);
            });
          }

          var volgende = doc.querySelector('[data-meer]');
          if (volgende && volgende.dataset.meerUrl) {
            knop.dataset.meerUrl = volgende.dataset.meerUrl;
            knop.textContent = origineel;
          } else {
            knop.hidden = true;
          }

          var nieuweTelling = doc.querySelector('[data-meer-telling]');
          if (telling) {
            if (nieuweTelling) telling.textContent = nieuweTelling.textContent;
            else telling.textContent = '';
          }

          // de nieuwe kaartjes moeten ook op de plusknop reageren
          veilig('toevoegknoppen', initQadd);
          bezig = false;
        })
        .catch(function () {
          knop.textContent = origineel;
          bezig = false;
        });
    });
  }

  /**
   * Elk onderdeel start apart met een eigen vangnet. Gaat er ergens iets
   * mis, dan blijft de rest gewoon werken.
   */
  function veilig(naam, fn) {
    try { fn(); } catch (e) { if (window.console) console.warn('DrankThuis: ' + naam, e); }
  }

  function init() {
    veilig('leeftijdscontrole', initAgeGate);
    veilig('installeren', initInstalleer);
    veilig('carrousel', initCarrousel);
    veilig('bovenbalk', initStickyHeader);
    veilig('menu', initNav);
    veilig('categoriemenu', initCatMenu);
    veilig('zoeken', initZoek);
    veilig('aantallen', initQuantity);
    veilig('mandjeregels', initCartLines);
    veilig('ballonnetjes', initTips);
    veilig('toevoegknoppen', initQadd);
    veilig('productformulier', initProductForm);
    veilig('tijdslot', initTimeslot);
    veilig('afrekenen', initCheckoutGuard);
    veilig('meer laden', initMeer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
